import React, {InputHTMLAttributes, useState} from "react";
import styled from "styled-components";
import _ from "lodash";
import IconEye from "../static/images/icon_eye.svg"

interface PasswordFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  value: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PasswordField: React.FC<PasswordFieldProps> = (props: PasswordFieldProps) => {
  const [showPass, setShowPass] = useState<boolean>(false);
 return (
   <FieldWrapper>
     <label htmlFor={props.id}>{props.label}</label>
     <InputWrapper>
       <input
         type={showPass ? "text" : "password"}
         autoComplete="new-password"
         id={props.id}
         value={props.value}
         onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange(e)}
         {..._.omit(props, ["id", "value", "onChange", "label"])}
       />
       <ShowButton
         role="switch"
         aria-checked={showPass}
         onClick={() => setShowPass(!showPass)}
         className={showPass ? "password-visible" : "password-hidden"}
       >
         <img src={IconEye} alt=""/>
         <span className="sr-only">{showPass ? "Piilota" : "Näytä"}</span>
       </ShowButton>
     </InputWrapper>
   </FieldWrapper>
 )
}

export default PasswordField;

const FieldWrapper = styled.div`

`;

const InputWrapper = styled.div`
  position: relative;
  
  input {
    padding-right: 50px;
  }
`;

const ShowButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  
  img {
    width: 25px;
    height: auto;
  }
  
  &.password-hidden {
    img {
      opacity: .5;
      filter: grayscale(1);
    }
  }
`;